import styles from './AdminModeBanner.module.scss';

function AdminModeBanner() {
  return (
    <div className={styles.adminModeBanner}>
      <p>Staff Mode</p>
    </div>
  );
}

export default AdminModeBanner;
